// extracted by mini-css-extract-plugin
export default {"main":"Summary_main__gcOmI","summary":"Summary_summary__JfPak","table":"Summary_table__WKENm"};